import { createBrowserRouter } from 'react-router-dom';
import routes from '@/initializers/src/router/routes';

const router = createBrowserRouter(routes);

export default router;
